import { z } from 'zod';
import { TelegramUsernameInput } from './event';

/** Блокировка организатора платформой (#190): посты с его ником не публикуются из импорта. */
export const OrganizerBlockDto = z.object({
  id: z.uuid(),
  /** Ник без `@`, в нижнем регистре. */
  username: z.string(),
  reason: z.string(),
  blockedBy: z.object({ id: z.uuid(), name: z.string() }).nullable(),
  createdAt: z.iso.datetime(),
});
export type OrganizerBlockDto = z.infer<typeof OrganizerBlockDto>;

export const CreateOrganizerBlockInput = z.object({
  username: TelegramUsernameInput,
  reason: z.string().trim().min(1).max(1000),
});
export type CreateOrganizerBlockInput = z.infer<typeof CreateOrganizerBlockInput>;
